import { ENV } from './env.js';

/**
 * Feature flags derived from the environment. Interpret `ENV` here, once;
 * entities and features import the resulting booleans rather than reading
 * `ENV.appEnv` themselves.
 */

/** `.env.sandbox` is the one env file that sets `VITE_APP_ENV`, so this fails closed elsewhere. */
export const SANDBOX_DEMO_ENABLED = ENV.appEnv === 'sandbox';

/** Hide workspace surfaces that cannot be demonstrated faithfully with synthetic data. */
export const SANDBOX_SIMPLIFIED_WORKSPACE_ENABLED =
  SANDBOX_DEMO_ENABLED && ENV.sandboxSimplifiedWorkspace;

/** Replace the legacy Requests UI with clinician Suggestions. */
export const PATIENT_SUGGESTIONS_ENABLED = ENV.futurePatientSuggestions;

/**
 * Phone sign-in skips reCAPTCHA so Playwright can use a Firebase test number.
 * Only the `e2e` / `e2e-sandbox` Vite modes set it, and it fails closed in
 * production whatever the env file says.
 */
export const FIREBASE_APP_VERIFICATION_DISABLED =
  ENV.firebaseAppVerificationDisabled && !ENV.isProduction;
